type IconName = 'sun' | 'moon' | 'github' | 'linkedin' | 'twitter' | 'email' | 'wom' | 'palette' | 'volume' | 'volumeMute' | 'settings' | 'spotify' | 'osrs' | 'instagram'

interface IconProps {
  name: IconName
  size?: number
  className?: string
}

const icons: Record<IconName, React.ReactElement> = {
  github: (
    <path d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z"/>
  ),
  linkedin: (
    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
  ),
  twitter: (
    <path d="M23.953 4.57a10 10 0 01-2.825.775 4.958 4.958 0 002.163-2.723c-.951.555-2.005.959-3.127 1.184a4.92 4.92 0 00-8.384 4.482C7.69 8.095 4.067 6.13 1.64 3.162a4.822 4.822 0 00-.666 2.475c0 1.71.87 3.213 2.188 4.096a4.904 4.904 0 01-2.228-.616v.06a4.923 4.923 0 003.946 4.827 4.996 4.996 0 01-2.212.085 4.936 4.936 0 004.604 3.417 9.867 9.867 0 01-6.102 2.105c-.39 0-.779-.023-1.17-.067a13.995 13.995 0 007.557 2.209c9.053 0 13.998-7.496 13.998-13.985 0-.21 0-.42-.015-.63A9.935 9.935 0 0024 4.59z"/>
  ),
  email: (
    <path d="M24 5.457v13.909c0 .904-.732 1.636-1.636 1.636h-3.819V11.73L12 16.64l-6.545-4.91v9.273H1.636A1.636 1.636 0 0 1 0 19.366V5.457c0-.904.732-1.636 1.636-1.636h3.819l6.545 4.91 6.545-4.91h3.819A1.636 1.636 0 0 1 24 5.457z"/>
  ),
  spotify: (
    <path d="M12 0C5.4 0 0 5.4 0 12s5.4 12 12 12 12-5.4 12-12S18.66 0 12 0zm5.521 17.34c-.24.359-.66.48-1.021.24-2.82-1.74-6.36-2.101-10.561-1.141-.418.122-.859-.179-.981-.78-.122-.42.18-.861.781-.983 4.621-1.06 8.462-.6 11.64 1.32.42.18.479.659.301 1.02l-.159.324zm1.44-3.3c-.301.42-.841.6-1.262.3-3.239-1.98-8.159-2.58-11.939-1.38-.479.12-1.02-.12-1.14-.6-.12-.48.12-1.021.6-1.141C9.6 9.9 15 10.561 18.72 12.84c.361.181.54.78.241 1.2zm.12-3.36C15.24 8.4 8.82 8.16 5.16 9.301c-.6.179-1.2-.181-1.38-.721-.18-.601.18-1.2.72-1.381 4.26-1.26 11.28-1.02 15.721 1.621.539.3.719 1.02.419 1.56-.299.421-1.02.599-1.559.3z"/>
  ),
  osrs: (
    <g>
      <rect x="2" y="10" width="5" height="9" rx="0.5" fill="currentColor"/>
      <rect x="8.5" y="4" width="5" height="15" rx="0.5" fill="currentColor"/>
      <rect x="15" y="13" width="5" height="6" rx="0.5" fill="currentColor"/>
      <polygon points="2,10 7,10 8,8.5 3,8.5" fill="currentColor" opacity="0.9"/>
      <polygon points="8.5,4 13.5,4 14.5,2.5 9.5,2.5" fill="currentColor" opacity="0.9"/>
      <polygon points="15,13 20,13 21,11.5 16,11.5" fill="currentColor" opacity="0.7"/>
      <polygon points="7,10 8,8.5 8,18.5 7,19" fill="currentColor" opacity="0.7"/>
      <polygon points="13.5,4 14.5,2.5 14.5,17.5 13.5,19" fill="currentColor" opacity="0.7"/>
      <polygon points="20,13 21,11.5 21,17.5 20,19" fill="currentColor" opacity="0.7"/>
    </g>
  ),
  instagram: (
    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
  ),
  wom: (
    <g>
      <path d="M2.18813 16.9146V13.6151L3.0217 14.1013L4.30679 13.0593H5.10564L7.18957 14.5528L9.20404 12.33L9.09985 13.754V14.5528L8.82199 15.4906L8.57886 15.6643V16.9146L8.30101 17.4356V18.5818L7.71056 19.1375L7.18957 19.5195L7.39797 20.5615L7.5369 22.1939H7.18957L6.42546 22.3329L6.28653 23.3054L5.66135 24L4.58465 22.9928L3.54268 23.5137L3.40376 22.055L3.16063 21.7771L2.08393 21.152L2.18813 20.7699V19.9363L2.39652 19.6585V18.9986L1.70187 17.9566L2.18813 16.9146Z" fill="currentColor"/>
      <path d="M2.70911 0.45152L1.84081 2.81331L2.91751 4.34153H8.54413L9.03039 2.36179L8.23154 0.104197L7.22431 2.74385L5.31403 0L4.34153 3.1259L2.70911 0.45152Z" fill="currentColor" fillOpacity="0.9"/>
      <path d="M1.21564 5.52242V6.66859C2.82492 7.35163 6.6686 8.19681 9.16933 6.11287C9.19267 6.09342 9.2158 6.07397 9.23879 6.05452V5.52242H1.21564ZM3.09118 3.92057L1.21564 1.38928V5.52242H9.23879V3.92057L9.09986 2.22286L8.96093 1.49348L8.47468 3.50795L7.25905 1.38928L5.86976 4.23733L4.37627 1.80607L3.09118 3.92057Z" fill="currentColor"/>
      <path d="M4.23734 10.2808C4.23734 11.4509 3.2888 12.3994 2.11867 12.3994C0.948538 12.3994 0 11.4509 0 10.2808C0 9.11065 0.948538 8.16211 2.11867 8.16211C3.2888 8.16211 4.23734 9.11065 4.23734 10.2808ZM8.68307 10.5586C8.68307 11.7288 7.73453 12.6773 6.5644 12.6773C5.39427 12.6773 4.44573 11.7288 4.44573 10.5586C4.44573 9.38851 5.39427 8.43997 6.5644 8.43997C7.73453 8.43997 8.68307 9.38851 8.68307 10.5586Z" fill="currentColor"/>
      <path d="M4.63905 9.67324L4.13252 9.62086L4.1637 10.8365L4.48046 10.906L4.63905 9.67324Z" fill="currentColor"/>
    </g>
  ),
  sun: (
    <g>
      <circle cx="12" cy="12" r="5" fill="currentColor"/>
      <path d="M12 1v2m0 18v2M4.22 4.22l1.42 1.42m12.72 12.72l1.42 1.42M1 12h2m18 0h2M4.22 19.78l1.42-1.42M18.36 5.64l1.42-1.42" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    </g>
  ),
  moon: (
    <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" fill="currentColor"/>
  ),
  palette: (
    <g>
      <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" fill="none"/>
      <circle cx="8" cy="8" r="2" fill="currentColor"/>
      <circle cx="16" cy="8" r="2" fill="currentColor"/>
      <circle cx="8" cy="16" r="2" fill="currentColor"/>
      <circle cx="16" cy="16" r="2" fill="currentColor"/>
      <circle cx="12" cy="12" r="1.5" fill="currentColor"/>
    </g>
  ),
  volume: (
    <g>
      <polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5" fill="currentColor"/>
      <path d="M15.54 8.46a5 5 0 0 1 0 7.07M19.07 4.93a10 10 0 0 1 0 14.14" stroke="currentColor" strokeWidth="2" strokeLinecap="round" fill="none"/>
    </g>
  ),
  volumeMute: (
    <g>
      <polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5" fill="currentColor"/>
      <line x1="23" y1="9" x2="17" y2="15" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
      <line x1="17" y1="9" x2="23" y2="15" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    </g>
  ),
  settings: (
    <g>
      <line x1="4" y1="21" x2="4" y2="14" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
      <line x1="4" y1="10" x2="4" y2="3" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
      <line x1="12" y1="21" x2="12" y2="12" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
      <line x1="12" y1="8" x2="12" y2="3" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
      <line x1="20" y1="21" x2="20" y2="16" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
      <line x1="20" y1="12" x2="20" y2="3" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
      <line x1="1" y1="14" x2="7" y2="14" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
      <line x1="9" y1="8" x2="15" y2="8" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
      <line x1="17" y1="16" x2="23" y2="16" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    </g>
  )
}

function Icon({ name, size = 24, className = '' }: IconProps) {
  const iconPath = icons[name]
  
  if (!iconPath) {
    console.warn(`Icon "${name}" not found`)
    return null
  }

  // Special handling for WOM icon which has different dimensions
  const viewBox = name === 'wom' ? '0 0 10 24' : '0 0 24 24'

  return (
    <svg 
      width={size} 
      height={size} 
      viewBox={viewBox} 
      fill="currentColor"
      className={className}
    >
      {iconPath}
    </svg>
  )
}

export default Icon
